import React from 'react';

import component, {classnames} from '../component';
import TopBanner from '../TopBanner';
import {HBox, VBox} from '../Box';
import TypicalContent from '../TypicalContent';



export default component('FlatPage', function({data}) {
  return (
    <div>
      <TopBanner />
      <HBox isContainer={true} width={4}>
        <TypicalContent
          data={data}
          title={data.get('title')}
          image={data.get('image')}
          text={data.get('body')}
        />
      </HBox>
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/pages/FlatPage.js